import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("contract") !== null && localStorage.getItem("contract") !== undefined && localStorage.getItem("contract") !== "") {

    data = JSON.parse(localStorage.getItem("contract"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getcontract: (state, action) => {
            localStorage.setItem("contract", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { getcontract } = Insider.actions;
export default Insider.reducer;